import LeagueCover from "../../shared/components/LeagueCover";
import type { LeagueDetail } from "@tnp/contracts";
import Button from "../../../../shared/components/Button";
import { getLeagueTexts } from "../../shared/leagueTexts";
import { getLeagueRosterTexts } from "../../shared/leagueRosterTexts";

export default function LeagueOverview({ league, onParticipants }: { league: LeagueDetail; onParticipants: () => void }) {
  const t = getLeagueTexts();
  return <section className="league-panel league-overview">
    <div className="league-management-header"><h2>{league.name}</h2><span className={`league-status league-status--${league.status}`}>{t[league.status]}</span></div>
    {league.imageUrl && <LeagueCover imageUrl={league.imageUrl} />}
    {league.description && <p>{league.description}</p>}
    <dl className="league-review-summary">
      <div><dt>{t.venue}</dt><dd>{league.venue || t.noVenue}</dd></div>
      <div><dt>{t.organizer}</dt><dd>{league.organizerName}</dd></div>
      <div><dt>{t.season}</dt><dd>{league.seasons.map(season => season.year).join(" · ")}</dd></div>
      <div><dt>{t.divisions}</dt><dd>{Array.from(new Set(league.seasons.flatMap(season => season.divisions.map(division => t[division.gender])))).join(" · ")}</dd></div>
    </dl>
    <div className="league-actions">
      <Button onClick={onParticipants}>{getLeagueRosterTexts().title}</Button>
      {league.status === "published" && <Button href={`#/ligas/${league.id}`} variant="ghost">{t.details}</Button>}
    </div>
  </section>;
}
